module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget widget-user"
  }, [_c('div', {
    staticClass: "widget-user-header",
    class: _vm.isBackgroundImage ? 'bg-black' : _vm.theme,
    style: (_vm.isBackgroundImage ? ("background: url('" + _vm.profileImage + "') center center;") : '')
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "widget-user-image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.profileImage,
      "alt": "User Avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('row', [_c('div', {
    staticClass: "col-sm-4 border-right"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v(_vm._s(_vm.infoList[0].count))]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.infoList[0].text))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 border-right"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v(_vm._s(_vm.infoList[1].count))]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.infoList[1].text))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v(_vm._s(_vm.infoList[2].count))]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.infoList[2].text))])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-026b28d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VASocialUser.v1.vue
// module id = 489
// module chunks = 1